module.exports = __webpack_public_path__ + "static/013_001-0ac357249210ffd3bfa0830e0cdcaedd.jpg";